import React from 'react';
import {Alert, Button, Form, Modal, Spinner} from "react-bootstrap";
import {createEvent} from "../../../api/Events";
import DateTimePicker from "react-datetime-picker";

function EventCreator() {
    const [modalShow, setModalShow] = React.useState(false);

    return (
        <>
            <Button variant="secondary" onClick={() => setModalShow(true)}>Créer un nouvel événement</Button>

            <FormularModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    );
}

function FormularModal(props) {
    const [title, setTitle] = React.useState("");
    const [text, setText] = React.useState("");
    const [type, setType] = React.useState("Sorties");
    const [link, setLink] = React.useState("");
    const [date, setDate] = React.useState(new Date());
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    async function handleSubmit() {
        const event = JSON.stringify({
            title: title,
            text: text,
            type: type,
            link: link,
            departure_date: date,
            return_date: date,
            user: {
                id: 5
            }
        });

        setLoading(true)

        const eventCreated = await createEvent(event);

        if (eventCreated.status === 201) {
            setLoading(false)
            window.location.href = "/events"
        } else if (eventCreated.status === 401) {
            setError('Il y a eut un problème lors de la création')
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Création d'un événement
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Titre <b style={{color: 'red'}}>*</b></Form.Label>
                        <Form.Control type="text" placeholder="Entrer le titre" value={title} onChange={e => setTitle(e.target.value)} />
                        <Form.Text className="text-muted" style={{textAlign: 'right', marginRight: 5}}>
                            {title.length} / 100
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Informations <b style={{color: 'red'}}>*</b></Form.Label>
                        <Form.Control as="textarea" rows={3} value={text} onChange={e => setText(e.target.value)}/>
                        <Form.Text className="text-muted" style={{textAlign: 'right', marginRight: 5}}>
                            {text.length} / 2000
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="typeSelector">
                        <Form.Label>Type <b style={{color: 'red'}}>*</b></Form.Label>
                        <Form.Control as="select" onChange={e => setType(e.target.value)} value={type}>
                            <option disabled>------</option>
                            <option value="Sorties">Sorties</option>
                            <option value="Week-end">Week-end</option>
                            <option value="Autres">Autres</option>
                        </Form.Control>
                    </Form.Group>

                    {type !== "Sorties" ? (
                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Lien du Google Form <b style={{color: 'red'}}>*</b></Form.Label>
                            <Form.Control type="text" placeholder="Lien" value={link} onChange={e => setLink(e.target.value)} />
                        </Form.Group>
                    ) : null}



                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>Date <b style={{color: 'red'}}>*</b></Form.Label>
                        <DateTimePicker onChange={v => setDate(v)} value={date} />
                    </Form.Group>

                    {error !== null ? (
                        <Alert variant='danger'>
                            {error}
                        </Alert>
                    ) : null}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>Close</Button>
                {loading ? (
                    <Spinner animation="grow" variant="primary" />
                ) : (
                    <Button variant="primary" onClick={handleSubmit}>Ajouter</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

export default EventCreator;
